import React from "react"
import { ButtonWrapper } from "./Theme"

const Button = ({
  variant = "primary",
  className,
  onClick,
  children,
  style = {},
  disabled = false,
  size = "lg",
  ...props
}) => {
  return (
    <ButtonWrapper
      onClick={onClick} 
      className={className} 
      variant={variant} 
      style={style}
      disabled={disabled}
      size={size}
      {...props}
    >
      {children}
    </ButtonWrapper>
  )
}

export default Button